"use client"

import { useState } from "react"
import { Link, useLocation } from "react-router-dom"
import "./Navigation.scss"

const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false)
  const location = useLocation()

  const isActive = (path) => location.pathname === path

  return (
    <nav className="navigation">
      <div className="container">
        <div className="nav-content">
          <Link to="/" className="nav-logo">
            Cakoi's
          </Link>

          {/* Desktop Navigation */}
          <div className="nav-links desktop">
            <Link to="/" className={`nav-link ${isActive("/") ? "active" : ""}`}>
              Home
            </Link>
            <Link to="/menu" className={`nav-link ${isActive("/menu") ? "active" : ""}`}>
              Menu
            </Link>
            <a href="#about" className="nav-link">
              About
            </a>
            <a href="#contact" className="nav-link">
              Contact
            </a>
            <Link to="/partner" className="btn btn-primary">
              Become a Partner
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button className="mobile-menu-btn" onClick={() => setIsOpen(!isOpen)}>
            {isOpen ? (
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" />
              </svg>
            ) : (
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M3 12h18M3 6h18M3 18h18" stroke="currentColor" strokeWidth="2" />
              </svg>
            )}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isOpen && (
          <div className="nav-links mobile">
            <Link to="/" className="nav-link" onClick={() => setIsOpen(false)}>
              Home
            </Link>
            <Link to="/menu" className="nav-link" onClick={() => setIsOpen(false)}>
              Menu
            </Link>
            <a href="#about" className="nav-link" onClick={() => setIsOpen(false)}>
              About
            </a>
            <a href="#contact" className="nav-link" onClick={() => setIsOpen(false)}>
              Contact
            </a>
            <Link to="/partner" className="btn btn-primary" onClick={() => setIsOpen(false)}>
              Become a Partner
            </Link>
          </div>
        )}
      </div>
    </nav>
  )
}

export default Navigation
